import React, { useState, useEffect, useRef } from 'react';
import { Field, Formik, Form } from 'formik';
import { TextInput, DatePicker, Dropdown, RenderIf, PlaintiffModal, DefendantModal } from '../../../../components';
import Constants from '../../../../Constants';
import { storeCaseInfoData } from '../../../../redux/actions/caseInfo';
import { useSelector, useDispatch } from 'react-redux';
import XSelect from '../../../../components/common/XSelect';
import XMultiSelectWrapper from '../../../../components/common/XMultiSelectWrapper';
import { CASE_TYPE, CASE_TYPE_MAP } from '../../../../utils/enum';
import { formikRefCapture, storeLiablityEstern } from '../../../../redux/actions/liabilty';
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import DeleteModal from '../../../../components/ui-control/deleteModal';
import CaseFormFooter from "../../../../components/ui-control/CaseFormFooter";
import { getDefaultCaseInfo, getDefaultClient, getDefaultDefendant } from '../../../../utils/formSchema';
import { ReactComponent as EditIconBlue } from '../../../../assets/icons/EditIconBlue.svg';
import { ReactComponent as EditIcon } from '../../../../assets/icons/EditIcon.svg';
import { ReactComponent as AddIcon } from '../../../../assets/icons/AddIcon.svg';
import LoggedInUserService from '../../../../services/AuthService';

const defaultCaseInfo = getDefaultCaseInfo();

const CaseInfoForm = ({ onSubmit, backToCases, innerRef,selectedTiffIndex,addNewPlainTiff,updatePlainTiff,deletePlainTiff,plainTiffs,setSelectedTiffIndex,addNewDefendant,defendants,updateDefendant,selectedDefendant,setSelectedDefendant,deleteDefendant, formSteps }) => {
    const [showPlaintiffModal, setShowPlaintiffModal] = useState(false);
    const [showDefendantModal, setShowDefendantModal] = useState(false);
    const dispatch = useDispatch();
    const caseData = useSelector(state => state.caseInformation.caseData);
    let liability = useSelector(state => state.liability.liability);
    const { teams } = useSelector((state) => state.users || {});
    const [isformEdit ,setEditform] = useState({
        caseInfo:false,
        clients:false,
        defendants:false,
    });
  
    const [isShowDeleteModal,setIsShowDeleteModal] = useState(false);
    const deleteFunc = useRef(null);

     useEffect(() => {
        if (caseData?.caseInfo == null) {
            dispatch(storeCaseInfoData({ caseInfo: defaultCaseInfo }));
        }
    }, [caseData, dispatch]);

    if (caseData?.caseInfo == null) {
        return null; // Prevent Formik from rendering with undefined values
    }
    
    let handleDeleteModal = (confirmed)=>{
        if (confirmed && typeof deleteFunc.current === 'function') {
            deleteFunc.current();
          }
        setIsShowDeleteModal(false);
        deleteFunc.current = null
    }

    // Remove Inapplicable Fields from liability form base on casetype
    const removeInapplicableFields = (values)=>{
        if((caseData?.caseInfo?.caseType === values.caseInfo.caseType) || Object.keys(liability || {}).length === 0){return}
        if(values.caseInfo.caseType === CASE_TYPE.AUTO_ACCIDENT){
            liability = {
                howincidentOccured : liability.howincidentOccured || [],
                policeReportData : liability.policeReportData || [],
                witnessStatements : liability.witnessStatements || [],
                accidentSceneFiles : liability.accidentSceneFiles || []
            }
        }
        else if(values.caseInfo.caseType === CASE_TYPE.DOG_BITE){
            liability = {
                howincidentOccured : liability.howincidentOccured || [],
                witnessStatements : liability.witnessStatements || [],
                incidentReports : liability.incidentReports || [],
                accidentSceneFiles : liability.accidentSceneFiles || []
            }
        } 
        else if(values.caseInfo.caseType === CASE_TYPE.TRIP_AND_FALL || values.caseInfo.caseType === CASE_TYPE.SLIP_AND_FALL ||values.caseInfo.caseType === CASE_TYPE.PREMISE_LIABILITY){
            liability = {
                howincidentOccured : liability.howincidentOccured || [],
                dangerousConditions : liability.dangerousConditions || [],
                factsRegardingNotice : liability.factsRegardingNotice || [],
                witnessStatements : liability.witnessStatements || [],
                incidentReports : liability.incidentReports || [],
                expertSafetyReport : liability.expertSafetyReport || [],
                accidentSceneFiles : liability.accidentSceneFiles || []
            }
        }
        dispatch(storeLiablityEstern(liability));
    }
    
    const isAdmin = LoggedInUserService.GetLoggedInUserData().isAdmin

    return (
        <>
        <Formik
            initialValues={{
                caseInfo : caseData?.caseInfo,
                clients : caseData?.clients || [getDefaultClient()],
                defendants  : caseData?.defendants || [getDefaultDefendant()],
                teamIds: caseData?.teamIds || []
            }}
            onSubmit={(values) => {
                values.caseInfo.caseType = values?.caseInfo.caseType === '' ? CASE_TYPE.AUTO_ACCIDENT : values?.caseInfo.caseType;
                values.caseInfo.stateOfIncident = values?.caseInfo.stateOfIncident ? values?.caseInfo.stateOfIncident : "California";
                values.caseInfo.isIncludeExhibit = !!values?.caseInfo.isIncludeExhibit;
                values.caseInfo.isForceReset = values.caseInfo.isForceReset ? values.caseInfo.isForceReset : false
                removeInapplicableFields(values);
                values.defendants = defendants;
                values.clients = plainTiffs;
                onSubmit({
                    caseInfo: values
                });
                dispatch(storeCaseInfoData(values));
            }}
            enableReinitialize={false}
        >
            {(formik) => (
                <Form
                    onKeyDown={(e)=>handleEnterKeyPress(e)}
                >
                    <div className="add-form p-0">
                        <div className="accordion form-background form-item-pd pb-4">
                                <div className="d-flex justify-content-between align-items-center w-100 me-3 mb-3">
                                    <h2>Case Information</h2>
                                </div>
                                <div className="row align-items-end">
                                    <div className="col-md-12">
                                        <div className="form-group w-50">
                                            <Field name="caseInfo.caseName" label="Case Name" component={TextInput} />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group w-50">
                                            <XSelect
                                                emptyOption={false}
                                                label="Case Type"
                                                value={formik.values.caseInfo.caseType}
                                                options={Object.values(CASE_TYPE_MAP)}
                                                onChange={(e) => {
                                                    formik.setFieldValue('caseInfo.caseType', e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group w-50">
                                            <XMultiSelectWrapper
                                                name="teamIds"
                                                label="Teams"
                                                options={teams}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row align-items-end">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <Field name="caseInfo.dateOfIncident" label="Date of incident" component={DatePicker}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 pe-0">
                                                <div className="form-group">
                                                    <Field name="caseInfo.stateOfIncident"
                                                        label="State where incident occurred"
                                                        component={Dropdown}
                                                        options={Constants.Dropdowns.States}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row align-items-end">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="label-style" htmlFor="flexSwitchCheckDefault">Attach Uploaded Docs as Exhibits to the Demand Letter</label>
                                                    <div className="input-field">
                                                        <label className="switch">
                                                            <Field type="checkbox" checked={formik.values.caseInfo.isIncludeExhibit} onChange={(e) => formik.setFieldValue('caseInfo.isIncludeExhibit', e.target.checked)} />
                                                            <span className="slider"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            { isAdmin && <div className="form-group">
                                                    <label className="label-style" htmlFor="flexSwitchCheckDefault">Force Reset?</label>
                                                    <div className="input-field">
                                                        <label className="switch">
                                                            <Field type="checkbox" checked={formik.values.caseInfo.isForceReset} onChange={(e) => formik.setFieldValue('caseInfo.isForceReset', e.target.checked)} />
                                                            <span className="slider"></span>
                                                        </label>
                                                    </div>
                                                </div>}
                                            </div>
                                            {/* <div className="col-md-6 text-end">
                                                    <button type='button' className="btn btn-theme btn-border" onClick={() => handleAddCaseInfo(formik.values)}>Continue to Client Information</button>
                                                </div> */}
                                        </div>
                                    </div>
                                </div>
                                <PlaintiffModal
                                    show={showPlaintiffModal}
                                    onClose={() => {setShowPlaintiffModal(false); setSelectedTiffIndex(0);}}
                                    formik={formik}
                                    selectedTiffIndex={selectedTiffIndex}
                                    updatePlainTiff={updatePlainTiff}
                                    isformEdit={isformEdit.clients}
                                    onSave={() => {
                                        setShowPlaintiffModal(false);
                                    }}
                                    addNewPlainTiff={addNewPlainTiff}
                                />
                                <DefendantModal
                                    show={showDefendantModal}
                                    onClose={() => { setShowDefendantModal(false); setSelectedDefendant(0);}}
                                    formik={formik}
                                    selectedDefendantIndex={selectedDefendant}
                                    updateDefendant={updateDefendant}
                                    isformEdit={isformEdit.defendants}
                                    onSave={() => {
                                        setShowDefendantModal(false);
                                    }}
                                    addNewDefendant={addNewDefendant}
                                />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="d-flex justify-content-between align-items-center case-info-bg px-3 py-2 rounded-top">
                                            <strong>Plaintiffs</strong>
                                            <a className="small fw-semibold custom-hover" onClick={() => {
                                                setSelectedTiffIndex(formik.values.clients.length);
                                                setShowPlaintiffModal(true);
                                            }} ><AddIcon /> Add Plaintiff</a>
                                        </div>

                                        {plainTiffs
                                            ?.filter((client) => client?.personalInfo?.clientName)
                                            ?.map((client, index) => (<div key={index} className="border-custom border-top-0 p-3 plaintiff-item">
                                                <div className="d-flex justify-content-between flex-end m-10">
                                                    <div>
                                                        <strong>{client?.personalInfo?.clientName}</strong>
                                                    </div>
                                                    
                                                    <div className='d-flex' style={{position:'absolute',right:'10px'}}>
                                                        <a onClick={() => {
                                                        setSelectedTiffIndex(index);
                                                        setShowPlaintiffModal(true);
                                                    }} className="text-primary small delete-btn"><EditIconBlue className="me-2" style={{ marginTop: '-3px' }} />Edit</a>
                                                        <button onClick={() => {
                                                            deletePlainTiff(index);
                                                            const copyData = [...formik.values.clients];
                                                            copyData.splice(index, 1);
                                                            formik.setFieldValue(`clients`, copyData);
                                                        }} type='button' className="delete-btn-tiff me-2">
                                                            <i className="fas fa-trash-alt"></i>
                                                        </button>
                                                    </div>
                                                    <div className='d-flex' style={{position:'absolute',right:'10px'}}>
                                                        <button type='button' className="delete-btn-tiff me-4" onClick={() => {
                                                            setSelectedTiffIndex(index);
                                                            setShowPlaintiffModal(true);
                                                        }}>
                                                            <EditIcon style={{ height: '15px', width: '15px' }} />
                                                        </button>
                                                        <button onClick={() => {
                                                            deletePlainTiff(index);
                                                            const copyData = [...formik.values.clients];
                                                            copyData.splice(index, 1);
                                                            formik.setFieldValue(`clients`, copyData);
                                                        }} type='button' className="delete-btn-tiff me-2">
                                                            <i className="fas fa-trash-alt"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="text-muted small m-10">{client?.personalInfo?.phoneNumber}</div>
                                                <div className="text-muted small m-10">{client?.personalInfo?.email}</div>
                                                <div className="text-muted small m-10">Insurance: <span className="fw-medium">{client?.insurance?.insuranceName}</span></div>
                                                <div className="text-muted small m-10">{client?.insurance?.adjuster?.name}</div>
                                                <div className="text-muted small m-10">{client?.insurance?.adjuster?.phoneNumber}</div>
                                                <div className="text-muted small">{client?.insurance?.adjuster?.email}</div>
                                            </div>))}
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex justify-content-between align-items-center case-info-bg px-3 py-2 rounded-top">
                                            <strong>Defendants</strong>
                                            <a className="small fw-semibold custom-hover" onClick={() => {
                                                setSelectedDefendant(formik.values.defendants.length);
                                                setShowDefendantModal(true);
                                            }}><AddIcon /> Add Defendant</a>
                                        </div>

                                        {defendants
                                            ?.filter((defendant) => defendant?.personalInfo?.name) // or any required field
                                            ?.map((defendant, index) => (<div key={index} className="border-custom border-top-0 p-3 plaintiff-item">
                                                <div className="d-flex justify-content-between">
                                                    <strong>{defendant?.personalInfo?.name}</strong>
                                                    {/* <a onClick={() => {
                                                        setSelectedDefendant(index);
                                                        setShowDefendantModal(true);
                                                    }} className="text-primary small"><EditIconBlue className="me-2" style={{ marginTop: '-3px' }} />Edit</a> */}
<div className='d-flex' style={{position:'absolute',right:'10px'}}>
                                                    <button type='button' className="delete-btn-tiff me-4" onClick={() => {
                                                        setSelectedDefendant(index);
                                                        setShowDefendantModal(true);
                                                    }}>
                                                        <EditIcon style={{height:'15px',width:'15px'}} />
                                                    </button>
                                                    <button onClick={()=>{
                                                        deleteDefendant(index);
                                                        const copyData = [...formik.values.defendants];
                                                        copyData.splice(index, 1);
                                                        formik.setFieldValue(`defendants`, copyData);
                                                        }} type='button' className="delete-btn-tiff me-2">
                                                        <i className="fas fa-trash-alt"></i>
                                                    </button>
                                                    </div>
                                                </div>
                                                <div className="text-muted small m-10">{defendant?.personalInfo?.phoneNumber}</div>
                                                <div className="text-muted small m-10">{defendant?.personalInfo?.email}</div>
                                                <div className="text-muted small m-10">Insurance: <span className="fw-medium">{defendant?.insurance?.insuranceName}</span></div>
                                                <div className="text-muted small m-10">{defendant?.insurance?.adjuster?.name}</div>
                                                <div className="text-muted small m-10">{defendant?.insurance?.adjuster?.phoneNumber}</div>
                                                <div className="text-muted small">{defendant?.insurance?.adjuster?.email}</div>
                                            </div>))}
                                    </div>
                                </div>

                                <div className="mt-3 mb-2">
                                    <a onClick={() => {
                                        setSelectedTiffIndex(formik.values.clients.length);
                                        setShowPlaintiffModal(true);
                                    }} className=" small me-3 fw-semibold custom-hover"><AddIcon className="me-2" style={{ marginTop: '-3px' }} />  Add Plaintiff</a>
                                    <a onClick={() => {
                                        setSelectedDefendant(formik.values.defendants.length);
                                        setShowDefendantModal(true);
                                    }} className="small fw-semibold custom-hover"><AddIcon className="me-2" style={{ marginTop: '-3px' }} />  Add Defendant</a>
                                </div>
                        </div>
                        <CaseFormFooter backToCases={backToCases} handlePrevious={null} innerRef={innerRef}  formSteps={formSteps}/>
                    </div>
                </Form>
            )
            }
        </Formik>
        <DeleteModal isShow={isShowDeleteModal} handleDeleteModal={handleDeleteModal}/>
        </>
    )
}

export default CaseInfoForm;